module.exports = __webpack_public_path__ + "img/table-icon.9e7e7bd9.png";